module.exports = __webpack_public_path__ + "img/lucy_profile.8fba56af.jpg";